// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const sagaAgentStateSchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  handle: z.string().max(64),
  walletAddress: z.string().max(200),
  chain: z.string().max(50),
  publicKey: z.string().max(500).optional(),
  homeHubUrl: z.string().max(500),
  directoryUrl: z.string().max(500).optional(),
  registrationTxHash: z.string().max(200).optional(),
  parentSagaId: z.string().max(200).optional(),
  cloneDepth: z.number().int().min(0).max(100).default(0),

  name: z.string().max(200),
  avatar: z.string().max(1000).optional(),
  headline: z.string().max(500).optional(),
  bio: z.string().max(5000).optional(),
  profileType: z.enum(['agent', 'human', 'hybrid']).default('agent'),

  currentSyncVersion: z.number().int().min(0).default(0),
  lastSyncAt: z.string().max(200).datetime().optional(),
  registeredSystems: z.array(z.string()).optional(),

  registeredAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
})

export type SagaAgentStateInput = z.infer<typeof sagaAgentStateSchema>
